// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Jobbf","title":"Info_title__24TmG","links":"Info_links__1jpaj","link":"Info_link__1TBX3","logo":"Info_logo__3MAl4"};